// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__25QSq","list":"BalanceDue_list__2z-KT","listRow":"BalanceDue_listRow__1eZBK","total":"BalanceDue_total__1uz1e"};